import { render, staticRenderFns } from "./ceric_user_proposal_completion.vue?vue&type=template&id=caa5e6f4&"
import script from "./ceric_user_proposal_completion.vue?vue&type=script&lang=js&"
export * from "./ceric_user_proposal_completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports